<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="150px">
        <el-form-item label="支付平台:" prop="channelName">
          <el-input v-model="params.channelName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="平台ID:" prop="cid">
          <el-input v-model="params.cid" size="small"></el-input>
        </el-form-item>
        <el-form-item label="支付方式选择:" :show-overflow-tooltip="true" prop="payType">
          <el-radio-group v-model="params.payType" size="small">
            <el-radio
              v-for="item in payMethods"
              :label="item.value"
              :key="item.label"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="平台支付权重:" prop="weight">
          <el-input v-model.number="params.weight" size="small"></el-input>
        </el-form-item>

        <el-form-item label="支付金额类型:" prop="category">
          <el-select v-model="params.category" clearable size="small" placeholder="请选择支付金额类型">
            <el-option label="固定" value="fixed"></el-option>
            <el-option label="活动" value="active"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额种类:" prop="amountTypesStringCent" v-if="params.category=='fixed'">
          <el-input v-model="params.amountTypesStringCent" size="small"></el-input>
        </el-form-item>

        <el-form-item label="最小支持金额(元):" prop="minMoney" v-if="params.category=='active'">
          <el-input v-model.number="params.minMoney" size="small"></el-input>
        </el-form-item>
        <el-form-item label="最大支持金额(元):" prop="maxMoney" v-if="params.category=='active'">
          <el-input v-model.number="params.maxMoney" size="small"></el-input>
        </el-form-item>
        <el-form-item label="渠道费率:" prop="rate">
          <el-input v-model="params.rate" size="small"></el-input>
        </el-form-item>
        <el-form-item label="激活时间段:" prop="activePeriod">
          <el-input v-model="params.activePeriod" size="small"></el-input>
        </el-form-item>
        <el-form-item label="激活状态:" prop="maxMoney">
          <el-switch v-model="params.active"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
// import {validatorNumber}  from '@/utils/validator'
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      params: {
        channelName: "",
        rate: "",
        activePeriod: "",
        cid: "",
        payType: "",
        minMoney: "",
        maxMoney: "",
        weight: "",
        category: "",
        amountTypes: [], //服务器
        amountTypesStringCent: "", //控件
        active: false,
      },
      payMethods: [
        { label: "支付宝", value: "alipay" },
        { label: "微信", value: "wechat" },
        { label: "银联", value: "union" },
        { label: "代充", value: "daichong" },
      ],
      rules: {
        channelName: [
          { required: true, message: "请输入支付平台", trigger: "blur" },
        ],
        rate: [{ required: true, message: "请输入渠道费率", trigger: "blur" }],
        activePeriod: [
          {
            required: true,
            message: "请输入激活时间段，格式:6-23",
            trigger: "blur",
          },
        ],
        cid: [{ required: true, message: "请输入平台ID", trigger: "blur" }],
        payType: [
          { required: true, message: "请选择支付方式", trigger: "blur" },
        ],
        weight: [
          { required: true, message: "请输入权重", trigger: "blur" },
          { type: "number", message: "权重必须为数字" },
        ],
        category: [
          { required: true, message: "请选择支付金额类型", trigger: "blur" },
        ],
        //  amountTypes:[
        //     {  message: "请输入输入数字、英文逗号", trigger: "blur"}
        //   ],
        // minMoney: [
        //   { message: "请输入最小支付金额", trigger: "blur" },
        //   { type: "number", message: "支付金额必须为数字" }
        // ],
        // maxMoney: [
        //   { message: "请输入最大支付金额", trigger: "blur" },
        //   { type: "number", message: "支付金额必须为数字" }
        // ]
      },
    };
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增支付方式") {
            this.addChannel();
          } else {
            this.editChannel();
          }
        } else {
          return false;
        }
      });
    },
    // 修改支付方式配置
    editChannel() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        minMoney: this.params.minMoney * 100,
        maxMoney: this.params.maxMoney * 100,
        amountTypes: this.params.amountTypesStringCent
          .split(",")
          .map((v) => 100 * +v),
        amountTypesStringCent: this.params.amountTypesStringCent, //type:string 控件
      });

      API.updateChannel(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改支付方式成功",
              type: "success",
            });
            this.$emit("handlerChannelList");
          } else {
            this.$message.error("修改支付方式失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 添加支付方式
    addChannel() {
      let params = Object.assign(this.params, {
        minMoney: this.params.minMoney * 100,
        maxMoney: this.params.maxMoney * 100,
        amountTypes: this.params.amountTypesStringCent
          .split(",")
          .map((v) => 100 * +v), //this.params.amountTypesStringCent 单位：元
        amountTypesStringCent: this.params.amountTypesStringCent, //type:string 控件
      });
      API.addChannel(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增支付方式成功",
              type: "success",
            });
            this.$emit("handlerChannelList");
          } else {
            this.$message.error("新增支付方式失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        channelName: "",
        cid: "",
        payType: "",
        minMoney: "",
        maxMoney: "",
        weight: "",
        category: "",
        amountTypes: [],
        amountTypesStringCent: "",
        active: false,
        rate: "",
        activePeriod: "",
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参k
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑支付方式";
        this.params.channelName = data.channelName;
        this.params.cid = data.cid;
        this.params.rate = data.rate;
        this.params.activePeriod = data.activePeriod;
        this.params.active = data.active;
        this.params.payType = data.payType;
        this.params.minMoney = data.minMoney / 100;
        this.params.maxMoney = data.maxMoney / 100;
        this.params.weight = data.weight;
        this.params.category = data.category;
        //data.amountTypes type:Array 单位分
        this.params.amountTypes = data.amountTypes; //表单过滤后的值
        this.id = data.id;
        this.params.amountTypesStringCent =
          data.amountTypes.length > 0
            ? data.amountTypes.map((v) => v / 100).join(",")
            : "";
      } else {
        this.title = "新增支付方式";
      }
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
